import { IS_FIREFOX } from './utils';

export const preferCodecs = (sdp: string) => {
  const sdpLines = sdp.split('\r\n');
  const pLines = [];

  sdpLines.forEach((sdpLine) => {
    const line = sdpLine.toLowerCase();
    if (line.includes('a=rtpmap') && line.includes('h264')) {
      pLines.push(sdpLine);
    }
  });

  const payloadTypes = pLines.map(getCodecPayloadType).filter((it) => null !== it);

  const arr = [];

  sdpLines.forEach((sdpLine) => {
    let setup = sdpLine;

    if (sdpLine.includes('a=fmtp:111')) {
      setup = sdpLine + ';stereo=1';
    }
    if (sdpLine.includes('a=fmtp')) {
      const match = /a=fmtp:(\d+)\s/.exec(sdpLine);
      if (match && match.length > 1 && payloadTypes.includes(match[1])) {
        setup = sdpLine + ';sps-pps-idr-in-keyframe=1';
      }
    }

    arr.push(setup);
  });

  return preferFirefoxCodecs(arr.join('\r\n'));
};

export const preferFirefoxCodecs = (sdp: string) => {
  if (!IS_FIREFOX) {
    return sdp;
  }

  const sdpLines = sdp.split('\r\n');
  const pLines = [];
  const slicedPayloadLines = [];

  sdpLines.forEach((sdpLine) => {
    const line = sdpLine.toLowerCase();
    if (line.includes('a=rtpmap') && line.includes('h264')) {
      pLines.push(sdpLine);
    }
  });

  if (pLines.length > 1) {
    slicedPayloadLines.push(...pLines.slice(1));
  }

  const payloadTypes = slicedPayloadLines.map(getCodecPayloadType).filter((it) => null !== it);
  const res = [];

  sdpLines.forEach((sdpLine) => {
    let setup = sdpLine;

    if (sdpLine.includes('a=setup')) {
      setup = 'a=setup:passive';
    }

    if (sdpLine.includes('m=audio') || sdpLine.includes('m=video')) {
      setup = sdpLine.split(' ').filter((it, index) => {
        return index < 3 || !payloadTypes.includes(it);
      }).join(' ');
    }

    if (sdpLine.includes('a=fmtp') || sdpLine.includes('a=rtcp-fb') || sdpLine.includes('a=rtpmap')) {
      const match = /a=(?:fmtp|rtcp-fb|rtpmap):(\d+)\s/.exec(sdpLine);
      if (match && match.length > 1 && payloadTypes.includes(match[1])) {
        return;
      }
    }
    res.push(setup);
  });

  return res.join('\r\n');
};

function getCodecPayloadType(sdpLine: string) {
  const match = /a=rtpmap:(\d+)\s/.exec(sdpLine);
  return match && match.length > 1 ? match[1] : null;
}
